<template>
  <div class="ipo-page">
    <!-- Дансны үлдэгдэл + товчнууд -->
    <div class="ipo-balance-cards">
      <balance-card />
      <balance-card :is-nominal="false" :account="iban" />
    </div>

    <!-- Захиалгын хэсэг -->
    <div class="ipo-section">
      <div class="ipo-section-header">{{ $t('ipo.order_section') }}</div>
      <div class="ipo-card">
        <div v-if="listLoading" class="ipo-loading">
          <b-spinner variant="primary" />
        </div>
        <div v-else-if="items.length === 0" class="ipo-empty">
          {{ $t('ipo.no_ipo') }}
        </div>

        <template v-if="items.length > 0">
          <ipo-selector />

          <ipo-detail v-if="selectedIpo && selectedIpo.detail" class="ipo-detail-section" />

          <div v-if="selectedIpo" class="ipo-order-area">
            <!-- <div v-if="String(selectedIpo.sell_type) === '3'" class="ipo-bond-type-tabs">
              <button
                class="ipo-bond-tab"
                :class="{ 'ipo-bond-tab--active': orderPayload.order_type == 2 }"
                @click="$store.dispatch('ipoOrder/selectOrderType', 2)"
              >{{ $t('ipo.bond_type_2') }}</button>
              <button
                class="ipo-bond-tab"
                :class="{ 'ipo-bond-tab--active': orderPayload.order_type == 1 }"
                @click="$store.dispatch('ipoOrder/selectOrderType', 1)"
              >{{ $t('ipo.bond_type_1') }}</button>
            </div> -->

            <div class="ipo-order-grid">
              <div class="ipo-order-panel">
                <ipo-make-order v-if="!hasActiveOrder" />
                <ipo-active-order v-else />
              </div>

              <div class="ipo-history-panel">
                <div v-if="orderLoading" class="ipo-history-loading">
                  <b-spinner variant="secondary" />
                </div>
                <div v-else-if="orderList.length === 0" class="ipo-history-empty">
                  <i class="fas fa-file ipo-empty-icon"></i>
                  <p>{{ $t('ipo.no_orders') }}</p>
                </div>
                <ipo-order-history v-else />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BalanceCard from '../components/BalanceCard/index.vue'
import IpoSelector from '../components/ipo/IpoSelector.vue'
import IpoDetail from '../components/ipo/IpoDetail.vue'
import IpoMakeOrder from '../components/ipo/IpoMakeOrder.vue'
import IpoActiveOrder from '../components/ipo/IpoActiveOrder.vue'
import IpoOrderHistory from '../components/ipo/IpoOrderHistory.vue'

export default {
  name: 'TradeIpo',
  components: {
    BalanceCard,
    IpoSelector,
    IpoDetail,
    IpoMakeOrder,
    IpoActiveOrder,
    IpoOrderHistory,
  },
  computed: {
    ...mapGetters('ipoOrder', [
      'items', 'selectedIpo', 'orderPayload',
      'hasActiveOrder', 'orderList', 'orderLoading', 'listLoading',
    ]),
    iban() {
      return this.$store.getters['user/iban']
    },
  },
  mounted() {
    this.fetchIpoList()
    this.fetchProgress()
  },
  methods: {
    ...mapActions('ipoOrder', ['fetchIpoList', 'fetchProgress']),
  },
}
</script>

<style lang="scss" src="../../sass/trade/ipo.scss" />
